import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";
import { House, SuitcaseSimple, ChatCircle, User } from "@phosphor-icons/react";

export const BottomNav = () => {
  const { user } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (!user) return null;

  const items = [
    { key: "home", label: t("nav_home"), icon: House, path: "/" },
    { key: "jobs", label: t("tab_my_jobs"), icon: SuitcaseSimple, path: "/dashboard" },
    { key: "msg", label: t("nav_messages"), icon: ChatCircle, path: "/messages" },
    { key: "profile", label: t("nav_profile"), icon: User, path: "/profiel" },
  ];

  return (
    <nav data-testid="bottom-nav" className="fixed bottom-0 inset-x-0 z-40 bg-[#0A0A0A]/95 backdrop-blur border-t border-white/10 md:hidden">
      <div className="flex items-stretch">
        {items.map(({ key, label, icon: Icon, path }) => {
          const active = pathname === path;
          return (
            <button key={key} data-testid={`bottomnav-${key}`} onClick={() => navigate(path)}
              className={`flex-1 flex flex-col items-center gap-0.5 py-2.5 transition-colors ${active ? "text-[#E11D2A]" : "text-zinc-400 hover:text-white"}`}>
              <Icon size={22} weight={active ? "fill" : "regular"} />
              <span className="text-[10px] font-semibold">{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
